import { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { api } from "@/lib/api";
import i18n from "@/i18n";

const AuthCtx = createContext(null);
const SettingsCtx = createContext({});

export function AppProviders({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({});
  const [unread, setUnread] = useState(0);
  const seq = useRef(0);

  const refresh = useCallback(async () => {
    const id = ++seq.current;
    try { const { data } = await api.get("/auth/me"); if (id !== seq.current) return; setUser(data); if (data.locale && data.locale !== i18n.language) i18n.changeLanguage(data.locale); }
    catch { if (id === seq.current) setUser(false); }
  }, []);

  useEffect(() => { refresh(); api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, [refresh]);

  useEffect(() => {
    if (!user) { setUnread(0); return; }
    const load = () => api.get("/notifications", { params: { limit: 1 } }).then((r) => {
      setUnread((prev) => { if (user?.role === "partner" && prev !== 0 && r.data.unread > prev) alertUser(); return r.data.unread; });
    }).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [user]);

  const login = (data) => { seq.current++; localStorage.setItem("zeeva_token", data.token); setUser(data.user); };
  const logout = async () => { seq.current++; try { await api.post("/auth/logout"); } catch {} localStorage.removeItem("zeeva_token"); setUser(false); };

  return (
    <SettingsCtx.Provider value={settings}>
      <AuthCtx.Provider value={{ user, login, logout, refresh, unread, setUnread }}>{children}</AuthCtx.Provider>
    </SettingsCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export const useSettings = () => useContext(SettingsCtx);

let _lastAlert = 0;
function alertUser() {
  const now = Date.now();
  if (now - _lastAlert < 15000) return;
  _lastAlert = now;
  try { if (navigator.vibrate) navigator.vibrate([200, 100, 200]); } catch {}
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const g = ctx.createGain(); g.gain.value = 0.08; g.connect(ctx.destination);
    const beep = (f, t0, d) => { const o = ctx.createOscillator(); o.type = "sine"; o.frequency.value = f; o.connect(g); o.start(ctx.currentTime + t0); o.stop(ctx.currentTime + t0 + d); };
    beep(880, 0, 0.22); beep(1175, 0.28, 0.3);
  } catch {}
  if ("Notification" in window && Notification.permission === "granted" && document.visibilityState !== "visible") {
    try { new Notification("ZEEVA PRO", { body: "لديك تنبيه جديد — طلب أو تحديث يحتاج انتباهك", icon: "/icon-192.png" }); } catch {}
  }
}
export const requestNotifyPermission = () => { if ("Notification" in window && Notification.permission === "default") Notification.requestPermission().catch(() => {}); };
